<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <template v-if="loading">
      <Load :loading-msg="loadingMsg" />
    </template>
    <template v-else>
      <template v-if="showInfo">
        <v-card>
          <v-card-title>
            Enviar nova foto
            <v-spacer />
            <v-btn
              icon
              @click="onCancel"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-file-input
              ref="file"
              v-model="files"
              accept=".png, .jpeg, .jpg"
              label="Enviar foto"
              :error-messages="errorMsg"
              @change="changeBtn"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="d-flex align-end"
              text="text"
              color="primary"
              :disabled="btnFile"
              @click="sendAvatar"
            >
              <v-icon>
                mdi-plus
              </v-icon>
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <template v-if="delAvatar">
        <v-card>
          <v-card-title>
            Excluir seu avatar?
            <v-spacer />
            <v-btn
              icon
              @click="onCancel"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            Tem certeza que deseja excluir seu avatar?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              rounded
              outlined
              text
              color="primary"
              @click="deleteAvatar()"
            >
              Excluir
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </template>
  </v-dialog>
</template>

<script>
import Load from '@/components/Loading.vue'

export default {
  components: {
    Load
  },

  props: {
    user: { type: Object, default: undefined },
    delete: { type: Boolean, default: true }
  },

  data: () => ({
    dataUser: {
      avatar: undefined
    },
    showInfo: true,
    endAvatar: false,
    msgAvatar: '',
    files: [],
    btnFile: true,
    errorMsg: '',
    loading: false,
    loadingMsg: '',
    delAvatar: false
  }),
  created () {
    this.action()
  },
  methods: {
    action () {
      if (this.user.avatar) {
        this.showInfo = false
        this.delAvatar = true
      }
    },
    changeBtn () {
      if (this.files) {
        this.btnFile = false
      } else {
        this.btnFile = true
      }
    },
    async sendAvatar () {
      const formData = new FormData()
      formData.append('avatar', this.files)
      try {
        await this.$api.sendAvatar(formData, this.user.id)
        this.$store.dispatch('setSnackBar', { text: 'Upload da foto concluido.' })
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível enviar, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.onSubmit()
      }
    },
    async deleteAvatar () {
      try {
        await this.$api.deleteAvatar(this.user.id)
        this.$store.dispatch('setSnackBar', { text: 'Foto excluida com sucesso.' })
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível excluir, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.onSubmit()
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit () {
      this.$emit('resolve', true)
    }
  }
}
</script>
